import axios from 'axios';
import toCamelCase from '@/helpers/toCamelCase';
import languagesParams from '@/helpers/languagesParams';
import countriesParams from '@/helpers/countriesParams';
import { DEMOGRAPHICS_WIDGET_LANGUAGES_DATA_KEY, DEMOGRAPHICS_WIDGET_COUNTRIES_DATA_KEY } from '@/assets/dashboard/cache-keys';
import { TOP_COUNTRIES_OPTION, TOP_LANGUAGES_OPTION } from '@/assets/dashboard/widget-settings';

export const state = () => ({
    languages: [],
    countries: []
});

export const getters = {
    languages: state => state.languages,
    totalLanguageStatuses: state => state.languages.map(item => item.statusCount).reduce((sum, count) => sum + count, 0),
    countries: state => state.countries,
    totalCountryStatuses: state => state.countries.map(item => item.statusCount).reduce((sum, count) => sum + count, 0),
    TOP_LANGUAGES_OPTION: () => TOP_LANGUAGES_OPTION,
    TOP_COUNTRIES_OPTION: () => TOP_COUNTRIES_OPTION,
    DEMOGRAPHICS_WIDGET_LANGUAGES_DATA_KEY: () => DEMOGRAPHICS_WIDGET_LANGUAGES_DATA_KEY,
    DEMOGRAPHICS_WIDGET_COUNTRIES_DATA_KEY: () => DEMOGRAPHICS_WIDGET_COUNTRIES_DATA_KEY
};

export const mutations = {
    SET_LANGUAGES(state, languages) {
        state.languages = languages;
    },

    SET_COUNTRIES(state, countries) {
        state.countries = countries;
    }
};

export const actions = {
    async getLanguages({ commit }, { accountId, range, comparedRange, properties }) {
        const res = await axios.getMethodOverridePost(
            '/v1/dashboard/demographics/languages',
            {
                params: languagesParams(accountId, range, comparedRange, properties),
                encodeURI: true
            }
        );

        const languages = toCamelCase(res.data);
        commit('SET_LANGUAGES', languages);

        return languages;
    },

    getLanguagesCSV(vuexContext, { accountId, range, comparedRange, properties }) {
        return axios.getMethodOverridePost(
            '/v1/dashboard/demographics/languages.csv',
            {
                params: languagesParams(accountId, range, comparedRange, properties),
                encodeURI: true
            }
        );
    },

    async getCountries({ commit }, { accountId, range, comparedRange, properties }) {
        const res = await axios.getMethodOverridePost(
            '/v1/dashboard/demographics/countries',
            {
                params: countriesParams(accountId, range, comparedRange, properties),
                encodeURI: true
            }
        );

        const countries = toCamelCase(res.data);
        commit('SET_COUNTRIES', countries);

        return countries;
    },

    getCountriesCSV(vuexContext, { accountId, range, comparedRange, properties }) {
        return axios.getMethodOverridePost(
            '/v1/dashboard/demographics/countries.csv',
            {
                params: countriesParams(accountId, range, comparedRange, properties),
                encodeURI: true
            }
        );
    }
};
